(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function initCollectionDescriptionTabs(scope) {
    var wrappers = (scope || document).querySelectorAll('.collection-description-bottom');

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.descInit) return;
      wrapper.dataset.descInit = 'true';

      var toggle = wrapper.querySelector('.collection-description-toggle');
      var content = wrapper.querySelector('.collection-description-content');
      if (!toggle || !content) return;

      function closeContent() {
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(function () {
          content.style.height = '0px';
          content.style.opacity = '0';
        });

        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');

        content.addEventListener(
          'transitionend',
          function onCloseEnd(e) {
            if (e.propertyName !== 'height') return;
            content.hidden = true;
            content.removeEventListener('transitionend', onCloseEnd);
          },
          { once: true }
        );
      }

      function openContent() {
        content.hidden = false;
        content.style.height = '0px';
        content.style.opacity = '0';

        requestAnimationFrame(function () {
          content.style.height = content.scrollHeight + 'px';
          content.style.opacity = '1';
        });

        toggle.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');

        content.addEventListener(
          'transitionend',
          function onOpenEnd(e) {
            if (e.propertyName !== 'height') return;
            content.style.height = 'auto';
            content.removeEventListener('transitionend', onOpenEnd);
          },
          { once: true }
        );
      }

      toggle.addEventListener('click', function () {
        if (toggle.classList.contains('is-open')) {
          closeContent();
        } else {
          openContent();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCollectionDescriptionTabs(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionDescriptionTabs(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
function initCarousels(container) {
  var containers = container
    ? container.querySelectorAll('.iav-carousel-container')
    : document.querySelectorAll('.iav-carousel-container');

  containers.forEach(function (iav) {
    if (iav.dataset.carouselInit) return;
    iav.dataset.carouselInit = 'true';

    var track = iav.querySelector('.iav-carousel-track');
    var slides = iav.querySelectorAll('.iav-carousel-slide');
    var next = iav.querySelector('.iav-next-btn');
    var prev = iav.querySelector('.iav-prev-btn');
    var index = 0;
    var loadedSlides = {};

    function loadSlideImage(slideIndex) {
      if (loadedSlides[slideIndex]) return;

      var slide = slides[slideIndex];
      if (!slide) return;

      var lazyPlaceholder = slide.querySelector('[data-lazy-placeholder]');
      if (!lazyPlaceholder) return;

      var imageUrl = lazyPlaceholder.dataset.imagePreview;
      var aspectRatio = lazyPlaceholder.dataset.aspectRatio;

      var img = document.createElement('img');

      img.onload = function () {
        lazyPlaceholder.innerHTML = '';

        var wrapper = document.createElement('div');
        wrapper.className = 'responsive-image';

        if (aspectRatio && aspectRatio > 0) {
          wrapper.style.position = 'relative';
          wrapper.style.width = '100%';
          wrapper.style.paddingBottom = (1 / aspectRatio) * 100 + '%';
        }

        img.style.position = 'absolute';
        img.style.top = 0;
        img.style.left = 0;
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';

        wrapper.appendChild(img);
        lazyPlaceholder.appendChild(wrapper);
      };

      img.src = imageUrl;
      loadedSlides[slideIndex] = true;
    }

    function update() {
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      loadSlideImage(index);

      setTimeout(function () {
        var nextIndex = (index + 1) % slides.length;
        loadSlideImage(nextIndex);
      }, 200);
    }

    if (next)
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        index = (index + 1) % slides.length;
        update();
      });

    if (prev)
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        index = (index - 1 + slides.length) % slides.length;
        update();
      });

    let startX = 0;

    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    });

    track.addEventListener('touchend', function (e) {
      let endX = e.changedTouches[0].clientX;

      if (startX - endX > 50) {
        index = (index + 1) % slides.length;
      } else if (endX - startX > 50) {
        index = (index - 1 + slides.length) % slides.length;
      }

      update();
    });

    if (slides.length > 1) {
      setTimeout(function () {
        loadSlideImage(1);
      }, 300);
    }

    loadSlideImage(0);
    update();
  });
}

var loadProductRecommendationsIntoSection = function () {
  var productRecommendationsSection = document.querySelector('.product-recommendations');
  if (productRecommendationsSection === null) {
    return;
  }

  var requestUrl = productRecommendationsSection.dataset.url;
  var request = new XMLHttpRequest();
  request.open('GET', requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement('div');
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML =
        container.querySelector('.product-recommendations').innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function () {
          return $(window).width() < 768;
        },
        false
      );

      initCarousels(productRecommendationsSection);
    }
  };
  request.send();
};

document.addEventListener('shopify:section:load', function (event) {
  if (
    document.querySelector(
      '[data-section-id="' + event.detail.sectionId + '"].product-recommendations'
    )
  ) {
    loadProductRecommendationsIntoSection();
  }
});

document.addEventListener('shopify:section:unload', function (event) {
  if (
    document.querySelector(
      '[data-section-id="' + event.detail.sectionId + '"].product-recommendations'
    )
  ) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});

document.addEventListener('DOMContentLoaded', function () {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
